import {Group, Pin} from "@mui/icons-material";
import PersonIcon from '@mui/icons-material/Person';
import {Grid, IconButton, Tooltip} from '@mui/material';
import React, {useState} from 'react';
import {useSelector} from "react-redux";
import TextField from "../../../../components/fields/textfield/TextField";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import SectionHeader from "../../../../components/section/SectionHeader";
import TitleHeader from "../../../../components/TitleHeader";
import {t} from "../../../../store/localization/TranslMessasge";
import {IApplicationState} from "../../../../store/Store";
import {UserPasswordChangeDialog} from "./UserPasswordChangeDialog";
import {UserRoleTranslator} from "./role/UserRoleTranslator";
import {UsersTranslationKey} from "./UsersTranslationKey";

export default function ProfilePage() {
    const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
    const userData = useSelector((state: IApplicationState) => state.user.userData!);

    function showChangePasswordDialog() {
        setPasswordDialogOpen(true);
    }

    function hideChangePasswordDialog() {
        setPasswordDialogOpen(false);
    }

    return (
            <>
                <Page>
                    <TitleHeader
                            title={t(UsersTranslationKey.PROFILE)}
                            left={
                                <Tooltip title={t(UsersTranslationKey.CHANGE_PASSWORD)}>
                                    <IconButton onClick={() => showChangePasswordDialog()}>
                                        <Pin/>
                                    </IconButton>
                                </Tooltip>
                            }/>
                    <PageContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SectionHeader icon={<PersonIcon color={"primary"} />} title={t(UsersTranslationKey.BASIC_DATA)} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                        id="login"
                                        label={t(UsersTranslationKey.USER_LOGIN_NAME)}
                                        value={userData.login}
                                        readOnly/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                        id="firstName"
                                        label={t(UsersTranslationKey.USER_FIRST_NAME)}
                                        value={userData.firstName}
                                        readOnly/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                        id="lastName"
                                        label={t(UsersTranslationKey.USER_LAST_NAME)}
                                        value={userData.lastName}
                                        readOnly/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                        id="email"
                                        label={t(UsersTranslationKey.USER_EMAIL)}
                                        value={userData.email}
                                        readOnly/>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                        id="note"
                                        label={t(UsersTranslationKey.NOTE)}
                                        value={userData.description}
                                        multiline={true}
                                        rows={3}
                                        readOnly/>
                            </Grid>

                            <Grid item xs={12}>
                                <SectionHeader icon={<Group color="primary" />} title={t(UsersTranslationKey.USER_ROLE)} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                        id="role"
                                        label={t(UsersTranslationKey.USER_ROLE)}
                                        value={userData.role ? UserRoleTranslator.get().translateUserRole(userData.role) : ""}
                                        readOnly/>
                            </Grid>
                        </Grid>
                    </PageContent>
                </Page>

                <UserPasswordChangeDialog
                        open={passwordDialogOpen}
                        userLogin={userData.login}
                        onClose={() => hideChangePasswordDialog()} />
            </>
    );
}
